<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.1571 16.666H3.84227V7.49935H16.1571M13.5182 1.66602V3.33268H6.48116V1.66602H4.7219V3.33268H3.84227C2.86588 3.33268 2.08301 4.07435 2.08301 4.99935V16.666C2.08301 17.108 2.26836 17.532 2.59828 17.8445C2.92821 18.1571 3.37568 18.3327 3.84227 18.3327H16.1571C16.6237 18.3327 17.0711 18.1571 17.4011 17.8445C17.731 17.532 17.9163 17.108 17.9163 16.666V4.99935C17.9163 4.55732 17.731 4.1334 17.4011 3.82084C17.0711 3.50828 16.6237 3.33268 16.1571 3.33268H15.2775V1.66602M14.3978 10.8327H9.99967V14.9993H14.3978V10.8327Z"
      fill="currentColor"
    />
  </svg>
</template>
